var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.46 77.14C17.46 81.25 20.79 84.59 24.91 84.59C29.02 84.59 32.36 81.26 32.36 77.14C32.36 73.03 29.03 69.69 24.91 69.69C20.8 69.7 17.46 73.03 17.46 77.14Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.52 65.62V87.24C73.52 90.49 70.89 93.12 67.64 93.12H12.76C9.51 93.12 6.88 90.49 6.88 87.24V12.76C6.88 9.51 9.51 6.88 12.76 6.88H67.64C70.89 6.88 73.52 9.51 73.52 12.76V33.39L79.4 25.02V8.84C79.4 4.51 75.89 1 71.56 1H8.84C4.51 1 1 4.51 1 8.84V91.16C1 95.49 4.51 99 8.84 99H71.56C75.89 99 79.4 95.49 79.4 91.16V57.26L73.52 65.62Z",
    fill: "#F7931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.72 20.41H65.68V25.11H14.72V20.41Z",
    fill: "#29ABE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.72 49.8H61.98L65.29 45.1H14.72V49.8Z",
    fill: "#29ABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.72 32.75H65.68V37.45H14.72V32.75Z",
    fill: "#29ABE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.15 28.53L98.37 25.36C99.41 23.87 99.14 21.88 97.66 20.84L92.3 17.09C90.81 16.05 88.71 16.38 87.67 17.87L85.45 21.04L96.15 28.53Z",
    fill: "#29ABE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.04 70.13L51 81.65L61.82 77.67L51.04 70.13Z",
    fill: "#29ABE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.55 22.3L51.81 69.04L62.52 76.54L95.26 29.8L84.55 22.3ZM59.94 66.53L59.04 65.9L84.18 30.02L85.08 30.65L59.94 66.53ZM63.22 68.76L62.35 68.15L87.43 32.35L88.3 32.96L63.22 68.76Z",
    fill: "#F7931E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaseIcon);
export default __webpack_public_path__ + "static/media/LeaseIcon.dc3d6fe6310f18e416a066cf8bbd879f.svg";
export { ForwardRef as ReactComponent };